<template>
  <Drawer
    width="400"
    :title="`${openedReceive ? '编辑' : '新增'}收款账号`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="收款账号" prop="account" style="width: 366px">
          <Input
            v-model="formItem.account"
            clearable
            placeholder="请填写收款账号"
          />
        </FormItem>
        <FormItem label="行号" prop="bankNo" style="width: 366px">
          <Input v-model="formItem.bankNo" clearable placeholder="请填写行号" />
        </FormItem>
        <FormItem label="账号简称" prop="abbr" style="width: 366px">
          <Input
            v-model="formItem.abbr"
            clearable
            placeholder="请填写账号简称"
          />
        </FormItem>
        <FormItem label="账号银行" prop="bank" style="width: 366px">
          <Input v-model="formItem.bank" clearable placeholder="请填写银行" />
        </FormItem>
        <FormItem label="公司" prop="company">
          <Select v-model="formItem.company" filterable clearable>
            <Option
              v-for="option in companyList"
              :value="option._id"
              :key="option._id"
              >{{ option.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="回款类型" prop="type">
          <CheckboxGroup v-model="formItem.type">
            <Checkbox label="trans">银行转账</Checkbox>
            <Checkbox label="bankAccBill">银承</Checkbox>
            <Checkbox label="commAccBill">商承</Checkbox>
            <Checkbox label="bankAccBillPaper">纸质银承</Checkbox>
            <Checkbox label="check">支票</Checkbox>
            <Checkbox label="cash">现金钞票</Checkbox>
            <Checkbox label="yun">云信通</Checkbox>
            <Checkbox label="jian">建信融通</Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="账号状态" prop="active" style="width: 366px">
          <RadioGroup v-model="formItem.radio">
            <Radio label="true">
              <span>正常</span>
            </Radio>
            <Radio label="false">
              <span>停用</span>
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="备注" prop="remark" style="width: 366px">
          <Input
            v-model="formItem.remark"
            type="textarea"
            placeholder="输入备注..."
          />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "EditBankAccountDrawer",
  data() {
    return {
      drawerOpened: false,
      formItem: {
        account: null,
        abbr: null,
        bank: null,
        type: [],
        radio: null,
        active: null,
        company: null,
        remark: null,
        bankNo: null,
      },
      openedReceive: null,
      ruleValidate: {
        account: [
          { required: true, message: "收款账号为必填项", trigger: "submit" },
        ],
        abbr: [
          { required: true, message: "账号简称为必填项", trigger: "submit" },
        ],
        bank: [{ required: true, message: "银行为必填项", trigger: "submit" }],
        company: [
          { required: true, message: "公司为必选项", trigger: "submit" },
        ],
        type: [
          {
            required: true,
            message: "汇款类型为必选项",
            trigger: "submit",
            type: "array",
          },
        ],
        radio: [
          {
            required: true,
            message: "账号状态为必选项",
            trigger: "submit",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      companyList: (state) => state.company.companyList,
      user: (state) => state.auth.currentUser,
    }),
  },
  methods: {
    ...mapActions({
      getCompanyList: "company/getCompanyListAction",
      createAccount: "bankAccount/createAccountAction",
      updateBankAccount: "bankAccount/updateBankAccountAction",
    }),
    async openDrawer(receive) {
      this.getCompanyList({});
      this.$refs["formItem"].resetFields();
      this.openedReceive = receive; // 如果有打开，则为编辑模式
      if (receive) {
        this.formItem.account = receive.account;
        this.formItem.abbr = receive.abbr;
        this.formItem.bank = receive.bank;
        this.formItem.company = receive.company._id;
        this.formItem.type = receive.type;
        this.formItem.remark = receive.remark;
        this.formItem.radio = String(receive.active);
      } else {
        this.formItem.radio = "true";
      }
      this.drawerOpened = true;
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.openedReceive) {
              this.formItem.active =
                this.formItem.radio === "false" ? false : true;
              delete this.formItem.radio;
              await this.updateBankAccount({
                id: this.openedReceive._id,
                data: this.formItem,
              });
            } else {
              this.formItem.active =
                this.formItem.radio === "false" ? false : true;
              delete this.formItem.radio;
              await this.createAccount(this.formItem);
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped></style>